import { Component, OnInit, Inject } from '@angular/core';
import { CalendarDetailsComponent } from '../calendar-details/calendar-details.component';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DialogData } from '../termsandconditions/termsandconditions.component';

@Component({
  selector: 'app-pre-post-medication-dialog',
  templateUrl: './pre-post-medication-dialog.component.html',
  styleUrls: ['./pre-post-medication-dialog.component.css']
})
export class PrePostMedicationDialogComponent implements OnInit {

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<CalendarDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
